unit unit_AenderungEmailRechnung;

interface

uses
  System.SysUtils, System.Classes, JS, Web, WEBLib.Graphics, WEBLib.Controls,
  WEBLib.Forms, WEBLib.Dialogs, DB, Vcl.Controls, WEBLib.Grids,
  XData.Web.JsonDataset, XData.Web.Dataset, Vcl.StdCtrls, WEBLib.StdCtrls,
  WEBLib.DBCtrls;

type
  TAenderungEmailRechnung = class(TForm)
    xdsKundendaten: TXDataWebDataSet;
    xdsKundendatenKundennummer: TStringField;
    xdsKundendatenGruppeKunden: TBooleanField;
    xdsKundendatenGruppeLieferanten: TBooleanField;
    xdsKundendatenGruppeSonstige: TBooleanField;
    xdsKundendatenGruppeNichtkunden: TBooleanField;
    xdsKundendatenKontaktgruppe: TStringField;
    xdsKundendatenNachname: TStringField;
    xdsKundendatenVorname: TStringField;
    xdsKundendatenAdresszeile2: TStringField;
    xdsKundendatenAdresszeile3: TStringField;
    xdsKundendatenStrasse: TStringField;
    xdsKundendatenPostleitzahl: TStringField;
    xdsKundendatenOrt: TStringField;
    xdsKundendatenLaenderkuerzel: TStringField;
    xdsKundendatenLand: TStringField;
    xdsKundendatenLaenderkennzeichen: TBooleanField;
    xdsKundendatenAdressanrede: TStringField;
    xdsKundendatenBriefanrede1: TStringField;
    xdsKundendatenAdresseBild: TStringField;
    xdsKundendatenLieferanschrift: TStringField;
    xdsKundendatenTelefonNummer: TStringField;
    xdsKundendatenTelefaxNummer: TStringField;
    xdsKundendatenMobilTelefon: TStringField;
    xdsKundendatenEMail: TStringField;
    xdsKundendatenInternet: TStringField;
    xdsKundendatenUmsatzsteuerID: TStringField;
    xdsKundendatenUmsatzsteuerausweis: TBooleanField;
    xdsKundendatenZahlungsbedingung: TIntegerField;
    xdsKundendatenTransportbedingung: TStringField;
    xdsKundendatenKeinNewsletter: TBooleanField;
    xdsKundendatenTelefonAlternativ: TStringField;
    xdsKundendatenTitel: TStringField;
    xdsKundendatenKundenklasseFarbe: TIntegerField;
    xdsKundendatenRechnungEmail: TStringField;
    xdsKundendatenLoginPW: TStringField;
    xdsKundendatenBesteuerungKey: TIntegerField;
    xdsKundendatenAuftraegeJahr: TFloatField;
    xdsKundendatenAuftraegeVorjahr: TFloatField;
    xdsKundendatenLieferadresseID: TIntegerField;
    xdsKundendatenUSTIDgeprueft: TDateTimeField;
    xdsKundendatenKontaktverbund: TStringField;
    xdsKundendatenHinweis: TStringField;
    xdsKundendatenLatitude: TFloatField;
    xdsKundendatenLongitude: TFloatField;
    xdsKundendatenkmLuftlinie: TFloatField;
    xdsKundendatenGoogleID: TStringField;
    xdsKundendatenGoogleUpdatedUTC: TDateTimeField;
    xdsKundendatenBundesland: TStringField;
    xdsKundendatenRegion: TStringField;
    xdsKundendatenMandatsreferenz: TStringField;
    xdsKundendatenMandatsreferenzVom: TDateTimeField;
    xdsKundendatenLastschriftArt: TStringField;
    xdsKundendatenMahnsperre: TBooleanField;
    xdsKundendatenSuchbegriff: TStringField;
    xdsKundendatenLieferanschriftDaten: TStringField;
    xdsKundendatenExportKasse: TBooleanField;
    xdsKundendatenLoeschvormerkungDatum: TDateTimeField;
    xdsKundendatenLoeschvormerkungGrund: TStringField;
    xdsKundendatenPseudonymisiert: TStringField;
    xdsKundendatenLoginAktiv: TIntegerField;
    xdsKundendatenSonstigeDaten: TStringField;
    TC: TTableControl;
    edtEmail: TDBEdit;
    sourceKundendaten: TDataSource;
    procedure WebFormShow(Sender: TObject);
    procedure xdsKundendatenAfterOpen(DataSet: TDataSet);
    procedure sourceKundendatenStateChange(Sender: TObject);
    procedure xdsKundendatenAfterPost(DataSet: TDataSet);
    procedure xdsKundendatenAfterApplyUpdates(Sender: TDataSet;
      Info: TResolveResults);
  private
    { Private-Deklarationen }
  public
    { Public-Deklarationen }
    buttonAbsenden:TButton;
    buttonzurueck:TButton;
    procedure buttonAbsendenclick(Sender:TObject);
    procedure buttonzurueckclick(Sender:TObject);
  protected procedure LoadDFMValues; override; end;

var
  AenderungEmailRechnung: TAenderungEmailRechnung;

implementation
  uses unit1, unit2;
{$R *.dfm}
procedure TAenderungEmailRechnung.buttonzurueckclick(Sender:TObject);
begin
  close;
end;

procedure TAenderungEmailRechnung.sourceKundendatenStateChange(Sender: TObject);
begin
  try
    if sourceKundendaten.State in dseditmodes then buttonAbsenden.Enabled:=true else buttonAbsenden.Enabled:=false;
  except

  end;
end;

procedure TAenderungEmailRechnung.buttonabsendenclick(Sender:TObject);
begin
  dm2.xdsProtokoll.Append;
  dm2.xdsProtokollDatum.AsDateTime:=date+time;
  dm2.xdsProtokollKundennummer.AsString:=xdsKundendatenKundennummer.AsString;
  dm2.xdsProtokollPruefungErforderlich.AsBoolean:=true;
  dm2.xdsProtokollNotiz.AsString:='Neue Emailadresse für Rechnung '+xdsKundendatenRechnungEmail.asstring+', Prüfung vornehmen '+InternetIpAdresse;
  dm2.xdsProtokoll.Post;
  dm2.xdsProtokoll.ApplyUpdates;
  xdsKundendaten.post;
end;

procedure TAenderungEmailRechnung.WebFormShow(Sender: TObject);
begin
  dm2.xdsProtokoll.Load;
  xdsKundendaten.Close;
  xdsKundendaten.QueryString:='$filter=Kundennummer eq '+QuotedStr(KundeKundennummer);
  xdsKundendaten.Load;
end;

procedure TAenderungEmailRechnung.xdsKundendatenAfterApplyUpdates(
  Sender: TDataSet; Info: TResolveResults);
  var
  i:integer;
begin
  for i := 0 to High(info.Records) do
  begin
    if info.Records[i].Error<>'' then showmessage(info.Records[i].Error);
  end;
  if info.Records[0].Error='' then
  begin
    showmessage('Ihre Änderung wurde durchgeführt.');
    close;
  end;
end;

procedure TAenderungEmailRechnung.xdsKundendatenAfterOpen(DataSet: TDataSet);
var
  myelement:TJSHTMLElement;
  i:integer;
begin
  TC.ColCount:=1;
  TC.RowCount:=3;

  TC.Cells[0,0]:='<h4>Abweichende Email für Rechnung';
  inc(i);
  myelement:=TC.cellelements[0,i];
  buttonzurueck:=TButton.Create(self);
  buttonzurueck.ElementClassName:='btn btn-info text-left m-1';
  buttonzurueck.HeightStyle:=ssauto;
  buttonzurueck.WidthStyle:=ssauto;
  buttonzurueck.tag:=0;
  buttonzurueck.Caption:='<< zurück';
  buttonzurueck.OnClick:=@buttonzurueckClick;
  buttonzurueck.ParentElement:=myelement;

  buttonAbsenden:=TButton.Create(self);
  buttonAbsenden.ElementClassName:='btn btn-info text-left m-1';
  buttonAbsenden.HeightStyle:=ssauto;
  buttonAbsenden.WidthStyle:=ssauto;
  buttonAbsenden.tag:=0;
  buttonAbsenden.Caption:='speichern';
  buttonAbsenden.OnClick:=@buttonAbsendenClick;
  buttonAbsenden.ParentElement:=myelement;

  inc(i);
  myelement:=TC.cellelements[0,i];
  edtEmail.ParentElement:=myelement;
end;

procedure TAenderungEmailRechnung.xdsKundendatenAfterPost(DataSet: TDataSet);
begin
xdsKundendaten.ApplyUpdates;
end;

procedure TAenderungEmailRechnung.LoadDFMValues;
begin
  inherited LoadDFMValues;

  TC := TTableControl.Create(Self);
  edtEmail := TDBEdit.Create(Self);
  xdsKundendaten := TXDataWebDataSet.Create(Self);
  xdsKundendatenKundennummer := TStringField.Create(Self);
  xdsKundendatenGruppeKunden := TBooleanField.Create(Self);
  xdsKundendatenGruppeLieferanten := TBooleanField.Create(Self);
  xdsKundendatenGruppeSonstige := TBooleanField.Create(Self);
  xdsKundendatenGruppeNichtkunden := TBooleanField.Create(Self);
  xdsKundendatenKontaktgruppe := TStringField.Create(Self);
  xdsKundendatenNachname := TStringField.Create(Self);
  xdsKundendatenVorname := TStringField.Create(Self);
  xdsKundendatenAdresszeile2 := TStringField.Create(Self);
  xdsKundendatenAdresszeile3 := TStringField.Create(Self);
  xdsKundendatenStrasse := TStringField.Create(Self);
  xdsKundendatenPostleitzahl := TStringField.Create(Self);
  xdsKundendatenOrt := TStringField.Create(Self);
  xdsKundendatenLaenderkuerzel := TStringField.Create(Self);
  xdsKundendatenLand := TStringField.Create(Self);
  xdsKundendatenLaenderkennzeichen := TBooleanField.Create(Self);
  xdsKundendatenAdressanrede := TStringField.Create(Self);
  xdsKundendatenBriefanrede1 := TStringField.Create(Self);
  xdsKundendatenAdresseBild := TStringField.Create(Self);
  xdsKundendatenLieferanschrift := TStringField.Create(Self);
  xdsKundendatenTelefonNummer := TStringField.Create(Self);
  xdsKundendatenTelefaxNummer := TStringField.Create(Self);
  xdsKundendatenMobilTelefon := TStringField.Create(Self);
  xdsKundendatenEMail := TStringField.Create(Self);
  xdsKundendatenInternet := TStringField.Create(Self);
  xdsKundendatenUmsatzsteuerID := TStringField.Create(Self);
  xdsKundendatenUmsatzsteuerausweis := TBooleanField.Create(Self);
  xdsKundendatenZahlungsbedingung := TIntegerField.Create(Self);
  xdsKundendatenTransportbedingung := TStringField.Create(Self);
  xdsKundendatenKeinNewsletter := TBooleanField.Create(Self);
  xdsKundendatenTelefonAlternativ := TStringField.Create(Self);
  xdsKundendatenTitel := TStringField.Create(Self);
  xdsKundendatenKundenklasseFarbe := TIntegerField.Create(Self);
  xdsKundendatenRechnungEmail := TStringField.Create(Self);
  xdsKundendatenLoginPW := TStringField.Create(Self);
  xdsKundendatenBesteuerungKey := TIntegerField.Create(Self);
  xdsKundendatenAuftraegeJahr := TFloatField.Create(Self);
  xdsKundendatenAuftraegeVorjahr := TFloatField.Create(Self);
  xdsKundendatenLieferadresseID := TIntegerField.Create(Self);
  xdsKundendatenUSTIDgeprueft := TDateTimeField.Create(Self);
  xdsKundendatenKontaktverbund := TStringField.Create(Self);
  xdsKundendatenHinweis := TStringField.Create(Self);
  xdsKundendatenLatitude := TFloatField.Create(Self);
  xdsKundendatenLongitude := TFloatField.Create(Self);
  xdsKundendatenkmLuftlinie := TFloatField.Create(Self);
  xdsKundendatenGoogleID := TStringField.Create(Self);
  xdsKundendatenGoogleUpdatedUTC := TDateTimeField.Create(Self);
  xdsKundendatenBundesland := TStringField.Create(Self);
  xdsKundendatenRegion := TStringField.Create(Self);
  xdsKundendatenMandatsreferenz := TStringField.Create(Self);
  xdsKundendatenMandatsreferenzVom := TDateTimeField.Create(Self);
  xdsKundendatenLastschriftArt := TStringField.Create(Self);
  xdsKundendatenMahnsperre := TBooleanField.Create(Self);
  xdsKundendatenSuchbegriff := TStringField.Create(Self);
  xdsKundendatenLieferanschriftDaten := TStringField.Create(Self);
  xdsKundendatenExportKasse := TBooleanField.Create(Self);
  xdsKundendatenLoeschvormerkungDatum := TDateTimeField.Create(Self);
  xdsKundendatenLoeschvormerkungGrund := TStringField.Create(Self);
  xdsKundendatenPseudonymisiert := TStringField.Create(Self);
  xdsKundendatenLoginAktiv := TIntegerField.Create(Self);
  xdsKundendatenSonstigeDaten := TStringField.Create(Self);
  sourceKundendaten := TDataSource.Create(Self);

  TC.BeforeLoadDFMValues;
  edtEmail.BeforeLoadDFMValues;
  xdsKundendaten.BeforeLoadDFMValues;
  xdsKundendatenKundennummer.BeforeLoadDFMValues;
  xdsKundendatenGruppeKunden.BeforeLoadDFMValues;
  xdsKundendatenGruppeLieferanten.BeforeLoadDFMValues;
  xdsKundendatenGruppeSonstige.BeforeLoadDFMValues;
  xdsKundendatenGruppeNichtkunden.BeforeLoadDFMValues;
  xdsKundendatenKontaktgruppe.BeforeLoadDFMValues;
  xdsKundendatenNachname.BeforeLoadDFMValues;
  xdsKundendatenVorname.BeforeLoadDFMValues;
  xdsKundendatenAdresszeile2.BeforeLoadDFMValues;
  xdsKundendatenAdresszeile3.BeforeLoadDFMValues;
  xdsKundendatenStrasse.BeforeLoadDFMValues;
  xdsKundendatenPostleitzahl.BeforeLoadDFMValues;
  xdsKundendatenOrt.BeforeLoadDFMValues;
  xdsKundendatenLaenderkuerzel.BeforeLoadDFMValues;
  xdsKundendatenLand.BeforeLoadDFMValues;
  xdsKundendatenLaenderkennzeichen.BeforeLoadDFMValues;
  xdsKundendatenAdressanrede.BeforeLoadDFMValues;
  xdsKundendatenBriefanrede1.BeforeLoadDFMValues;
  xdsKundendatenAdresseBild.BeforeLoadDFMValues;
  xdsKundendatenLieferanschrift.BeforeLoadDFMValues;
  xdsKundendatenTelefonNummer.BeforeLoadDFMValues;
  xdsKundendatenTelefaxNummer.BeforeLoadDFMValues;
  xdsKundendatenMobilTelefon.BeforeLoadDFMValues;
  xdsKundendatenEMail.BeforeLoadDFMValues;
  xdsKundendatenInternet.BeforeLoadDFMValues;
  xdsKundendatenUmsatzsteuerID.BeforeLoadDFMValues;
  xdsKundendatenUmsatzsteuerausweis.BeforeLoadDFMValues;
  xdsKundendatenZahlungsbedingung.BeforeLoadDFMValues;
  xdsKundendatenTransportbedingung.BeforeLoadDFMValues;
  xdsKundendatenKeinNewsletter.BeforeLoadDFMValues;
  xdsKundendatenTelefonAlternativ.BeforeLoadDFMValues;
  xdsKundendatenTitel.BeforeLoadDFMValues;
  xdsKundendatenKundenklasseFarbe.BeforeLoadDFMValues;
  xdsKundendatenRechnungEmail.BeforeLoadDFMValues;
  xdsKundendatenLoginPW.BeforeLoadDFMValues;
  xdsKundendatenBesteuerungKey.BeforeLoadDFMValues;
  xdsKundendatenAuftraegeJahr.BeforeLoadDFMValues;
  xdsKundendatenAuftraegeVorjahr.BeforeLoadDFMValues;
  xdsKundendatenLieferadresseID.BeforeLoadDFMValues;
  xdsKundendatenUSTIDgeprueft.BeforeLoadDFMValues;
  xdsKundendatenKontaktverbund.BeforeLoadDFMValues;
  xdsKundendatenHinweis.BeforeLoadDFMValues;
  xdsKundendatenLatitude.BeforeLoadDFMValues;
  xdsKundendatenLongitude.BeforeLoadDFMValues;
  xdsKundendatenkmLuftlinie.BeforeLoadDFMValues;
  xdsKundendatenGoogleID.BeforeLoadDFMValues;
  xdsKundendatenGoogleUpdatedUTC.BeforeLoadDFMValues;
  xdsKundendatenBundesland.BeforeLoadDFMValues;
  xdsKundendatenRegion.BeforeLoadDFMValues;
  xdsKundendatenMandatsreferenz.BeforeLoadDFMValues;
  xdsKundendatenMandatsreferenzVom.BeforeLoadDFMValues;
  xdsKundendatenLastschriftArt.BeforeLoadDFMValues;
  xdsKundendatenMahnsperre.BeforeLoadDFMValues;
  xdsKundendatenSuchbegriff.BeforeLoadDFMValues;
  xdsKundendatenLieferanschriftDaten.BeforeLoadDFMValues;
  xdsKundendatenExportKasse.BeforeLoadDFMValues;
  xdsKundendatenLoeschvormerkungDatum.BeforeLoadDFMValues;
  xdsKundendatenLoeschvormerkungGrund.BeforeLoadDFMValues;
  xdsKundendatenPseudonymisiert.BeforeLoadDFMValues;
  xdsKundendatenLoginAktiv.BeforeLoadDFMValues;
  xdsKundendatenSonstigeDaten.BeforeLoadDFMValues;
  sourceKundendaten.BeforeLoadDFMValues;
  try
    Name := 'AenderungEmailRechnung';
    Width := 166;
    Height := 278;
    CSSLibrary := cssBootstrap;
    ElementFont := efCSS;
    SetEvent(Self, 'OnShow', 'WebFormShow');
    TC.SetParentComponent(Self);
    TC.Name := 'TC';
    TC.Left := 0;
    TC.Top := 0;
    TC.Width := 125;
    TC.Height := 256;
    TC.ElementClassName := 'table table-hover table-bordered table-striped';
    TC.WidthStyle := ssPercent;
    TC.BorderColor := clSilver;
    TC.ChildOrder := 2;
    TC.ColHeader := False;
    TC.ElementHeaderClassName := 'table-info';
    TC.ElementTableClassName := 'table table-hover table-bordered table-striped';
    TC.WordWrap := True;
    TC.ColCount := 2;
    edtEmail.SetParentComponent(Self);
    edtEmail.Name := 'edtEmail';
    edtEmail.Left := 21;
    edtEmail.Top := 160;
    edtEmail.Width := 250;
    edtEmail.Height := 22;
    edtEmail.ChildOrder := 2;
    edtEmail.ElementClassName := 'form-control email';
    edtEmail.ElementFont := efCSS;
    edtEmail.HeightStyle := ssAuto;
    edtEmail.HeightPercent := 100.000000000000000000;
    edtEmail.MaxLength := 50;
    edtEmail.Text := 'edtEmail';
    edtEmail.TextHint := 'Email-Adresse eintragen';
    edtEmail.WidthPercent := 100.000000000000000000;
    edtEmail.DataField := 'RechnungEmail';
    edtEmail.DataSource := sourceKundendaten;
    xdsKundendaten.SetParentComponent(Self);
    xdsKundendaten.Name := 'xdsKundendaten';
    xdsKundendaten.AfterApplyUpdates := xdsKundendatenAfterApplyUpdates;
    xdsKundendaten.AfterOpen := xdsKundendatenAfterOpen;
    xdsKundendaten.AfterPost := xdsKundendatenAfterPost;
    xdsKundendaten.EntitySetName := 'Adressen';
    xdsKundendaten.Connection := DM2.XDataWebConnection1;
    xdsKundendaten.Left := 40;
    xdsKundendaten.Top := 104;
    xdsKundendatenKundennummer.SetParentComponent(xdsKundendaten);
    xdsKundendatenKundennummer.Name := 'xdsKundendatenKundennummer';
    xdsKundendatenKundennummer.FieldName := 'Kundennummer';
    xdsKundendatenKundennummer.Size := 13;
    xdsKundendatenGruppeKunden.SetParentComponent(xdsKundendaten);
    xdsKundendatenGruppeKunden.Name := 'xdsKundendatenGruppeKunden';
    xdsKundendatenGruppeKunden.FieldName := 'GruppeKunden';
    xdsKundendatenGruppeLieferanten.SetParentComponent(xdsKundendaten);
    xdsKundendatenGruppeLieferanten.Name := 'xdsKundendatenGruppeLieferanten';
    xdsKundendatenGruppeLieferanten.FieldName := 'GruppeLieferanten';
    xdsKundendatenGruppeSonstige.SetParentComponent(xdsKundendaten);
    xdsKundendatenGruppeSonstige.Name := 'xdsKundendatenGruppeSonstige';
    xdsKundendatenGruppeSonstige.FieldName := 'GruppeSonstige';
    xdsKundendatenGruppeNichtkunden.SetParentComponent(xdsKundendaten);
    xdsKundendatenGruppeNichtkunden.Name := 'xdsKundendatenGruppeNichtkunden';
    xdsKundendatenGruppeNichtkunden.FieldName := 'GruppeNichtkunden';
    xdsKundendatenKontaktgruppe.SetParentComponent(xdsKundendaten);
    xdsKundendatenKontaktgruppe.Name := 'xdsKundendatenKontaktgruppe';
    xdsKundendatenKontaktgruppe.FieldName := 'Kontaktgruppe';
    xdsKundendatenKontaktgruppe.Size := 50;
    xdsKundendatenNachname.SetParentComponent(xdsKundendaten);
    xdsKundendatenNachname.Name := 'xdsKundendatenNachname';
    xdsKundendatenNachname.FieldName := 'Nachname';
    xdsKundendatenNachname.Size := 40;
    xdsKundendatenVorname.SetParentComponent(xdsKundendaten);
    xdsKundendatenVorname.Name := 'xdsKundendatenVorname';
    xdsKundendatenVorname.FieldName := 'Vorname';
    xdsKundendatenVorname.Size := 40;
    xdsKundendatenAdresszeile2.SetParentComponent(xdsKundendaten);
    xdsKundendatenAdresszeile2.Name := 'xdsKundendatenAdresszeile2';
    xdsKundendatenAdresszeile2.FieldName := 'Adresszeile2';
    xdsKundendatenAdresszeile2.Size := 40;
    xdsKundendatenAdresszeile3.SetParentComponent(xdsKundendaten);
    xdsKundendatenAdresszeile3.Name := 'xdsKundendatenAdresszeile3';
    xdsKundendatenAdresszeile3.FieldName := 'Adresszeile3';
    xdsKundendatenAdresszeile3.Size := 40;
    xdsKundendatenStrasse.SetParentComponent(xdsKundendaten);
    xdsKundendatenStrasse.Name := 'xdsKundendatenStrasse';
    xdsKundendatenStrasse.FieldName := 'Strasse';
    xdsKundendatenStrasse.Size := 40;
    xdsKundendatenPostleitzahl.SetParentComponent(xdsKundendaten);
    xdsKundendatenPostleitzahl.Name := 'xdsKundendatenPostleitzahl';
    xdsKundendatenPostleitzahl.FieldName := 'Postleitzahl';
    xdsKundendatenPostleitzahl.Size := 6;
    xdsKundendatenOrt.SetParentComponent(xdsKundendaten);
    xdsKundendatenOrt.Name := 'xdsKundendatenOrt';
    xdsKundendatenOrt.FieldName := 'Ort';
    xdsKundendatenOrt.Size := 40;
    xdsKundendatenLaenderkuerzel.SetParentComponent(xdsKundendaten);
    xdsKundendatenLaenderkuerzel.Name := 'xdsKundendatenLaenderkuerzel';
    xdsKundendatenLaenderkuerzel.FieldName := 'Laenderkuerzel';
    xdsKundendatenLaenderkuerzel.Size := 5;
    xdsKundendatenLand.SetParentComponent(xdsKundendaten);
    xdsKundendatenLand.Name := 'xdsKundendatenLand';
    xdsKundendatenLand.FieldName := 'Land';
    xdsKundendatenLand.Size := 40;
    xdsKundendatenLaenderkennzeichen.SetParentComponent(xdsKundendaten);
    xdsKundendatenLaenderkennzeichen.Name := 'xdsKundendatenLaenderkennzeichen';
    xdsKundendatenLaenderkennzeichen.FieldName := 'Laenderkennzeichen';
    xdsKundendatenAdressanrede.SetParentComponent(xdsKundendaten);
    xdsKundendatenAdressanrede.Name := 'xdsKundendatenAdressanrede';
    xdsKundendatenAdressanrede.FieldName := 'Adressanrede';
    xdsKundendatenAdressanrede.Size := 15;
    xdsKundendatenBriefanrede1.SetParentComponent(xdsKundendaten);
    xdsKundendatenBriefanrede1.Name := 'xdsKundendatenBriefanrede1';
    xdsKundendatenBriefanrede1.FieldName := 'Briefanrede1';
    xdsKundendatenBriefanrede1.Size := 255;
    xdsKundendatenAdresseBild.SetParentComponent(xdsKundendaten);
    xdsKundendatenAdresseBild.Name := 'xdsKundendatenAdresseBild';
    xdsKundendatenAdresseBild.FieldName := 'AdresseBild';
    xdsKundendatenAdresseBild.Size := 255;
    xdsKundendatenLieferanschrift.SetParentComponent(xdsKundendaten);
    xdsKundendatenLieferanschrift.Name := 'xdsKundendatenLieferanschrift';
    xdsKundendatenLieferanschrift.FieldName := 'Lieferanschrift';
    xdsKundendatenLieferanschrift.Size := 255;
    xdsKundendatenTelefonNummer.SetParentComponent(xdsKundendaten);
    xdsKundendatenTelefonNummer.Name := 'xdsKundendatenTelefonNummer';
    xdsKundendatenTelefonNummer.FieldName := 'TelefonNummer';
    xdsKundendatenTelefonNummer.Size := 25;
    xdsKundendatenTelefaxNummer.SetParentComponent(xdsKundendaten);
    xdsKundendatenTelefaxNummer.Name := 'xdsKundendatenTelefaxNummer';
    xdsKundendatenTelefaxNummer.FieldName := 'TelefaxNummer';
    xdsKundendatenTelefaxNummer.Size := 25;
    xdsKundendatenMobilTelefon.SetParentComponent(xdsKundendaten);
    xdsKundendatenMobilTelefon.Name := 'xdsKundendatenMobilTelefon';
    xdsKundendatenMobilTelefon.FieldName := 'MobilTelefon';
    xdsKundendatenMobilTelefon.Size := 25;
    xdsKundendatenEMail.SetParentComponent(xdsKundendaten);
    xdsKundendatenEMail.Name := 'xdsKundendatenEMail';
    xdsKundendatenEMail.FieldName := 'EMail';
    xdsKundendatenEMail.Size := 50;
    xdsKundendatenInternet.SetParentComponent(xdsKundendaten);
    xdsKundendatenInternet.Name := 'xdsKundendatenInternet';
    xdsKundendatenInternet.FieldName := 'Internet';
    xdsKundendatenInternet.Size := 50;
    xdsKundendatenUmsatzsteuerID.SetParentComponent(xdsKundendaten);
    xdsKundendatenUmsatzsteuerID.Name := 'xdsKundendatenUmsatzsteuerID';
    xdsKundendatenUmsatzsteuerID.FieldName := 'UmsatzsteuerID';
    xdsKundendatenUmsatzsteuerausweis.SetParentComponent(xdsKundendaten);
    xdsKundendatenUmsatzsteuerausweis.Name := 'xdsKundendatenUmsatzsteuerausweis';
    xdsKundendatenUmsatzsteuerausweis.FieldName := 'Umsatzsteuerausweis';
    xdsKundendatenZahlungsbedingung.SetParentComponent(xdsKundendaten);
    xdsKundendatenZahlungsbedingung.Name := 'xdsKundendatenZahlungsbedingung';
    xdsKundendatenZahlungsbedingung.FieldName := 'Zahlungsbedingung';
    xdsKundendatenTransportbedingung.SetParentComponent(xdsKundendaten);
    xdsKundendatenTransportbedingung.Name := 'xdsKundendatenTransportbedingung';
    xdsKundendatenTransportbedingung.FieldName := 'Transportbedingung';
    xdsKundendatenTransportbedingung.Size := 100;
    xdsKundendatenKeinNewsletter.SetParentComponent(xdsKundendaten);
    xdsKundendatenKeinNewsletter.Name := 'xdsKundendatenKeinNewsletter';
    xdsKundendatenKeinNewsletter.FieldName := 'KeinNewsletter';
    xdsKundendatenTelefonAlternativ.SetParentComponent(xdsKundendaten);
    xdsKundendatenTelefonAlternativ.Name := 'xdsKundendatenTelefonAlternativ';
    xdsKundendatenTelefonAlternativ.FieldName := 'TelefonAlternativ';
    xdsKundendatenTelefonAlternativ.Size := 50;
    xdsKundendatenTitel.SetParentComponent(xdsKundendaten);
    xdsKundendatenTitel.Name := 'xdsKundendatenTitel';
    xdsKundendatenTitel.FieldName := 'Titel';
    xdsKundendatenKundenklasseFarbe.SetParentComponent(xdsKundendaten);
    xdsKundendatenKundenklasseFarbe.Name := 'xdsKundendatenKundenklasseFarbe';
    xdsKundendatenKundenklasseFarbe.FieldName := 'KundenklasseFarbe';
    xdsKundendatenRechnungEmail.SetParentComponent(xdsKundendaten);
    xdsKundendatenRechnungEmail.Name := 'xdsKundendatenRechnungEmail';
    xdsKundendatenRechnungEmail.FieldName := 'RechnungEmail';
    xdsKundendatenRechnungEmail.Size := 50;
    xdsKundendatenLoginPW.SetParentComponent(xdsKundendaten);
    xdsKundendatenLoginPW.Name := 'xdsKundendatenLoginPW';
    xdsKundendatenLoginPW.FieldName := 'LoginPW';
    xdsKundendatenBesteuerungKey.SetParentComponent(xdsKundendaten);
    xdsKundendatenBesteuerungKey.Name := 'xdsKundendatenBesteuerungKey';
    xdsKundendatenBesteuerungKey.FieldName := 'BesteuerungKey';
    xdsKundendatenAuftraegeJahr.SetParentComponent(xdsKundendaten);
    xdsKundendatenAuftraegeJahr.Name := 'xdsKundendatenAuftraegeJahr';
    xdsKundendatenAuftraegeJahr.FieldName := 'AuftraegeJahr';
    xdsKundendatenAuftraegeVorjahr.SetParentComponent(xdsKundendaten);
    xdsKundendatenAuftraegeVorjahr.Name := 'xdsKundendatenAuftraegeVorjahr';
    xdsKundendatenAuftraegeVorjahr.FieldName := 'AuftraegeVorjahr';
    xdsKundendatenLieferadresseID.SetParentComponent(xdsKundendaten);
    xdsKundendatenLieferadresseID.Name := 'xdsKundendatenLieferadresseID';
    xdsKundendatenLieferadresseID.FieldName := 'LieferadresseID';
    xdsKundendatenUSTIDgeprueft.SetParentComponent(xdsKundendaten);
    xdsKundendatenUSTIDgeprueft.Name := 'xdsKundendatenUSTIDgeprueft';
    xdsKundendatenUSTIDgeprueft.FieldName := 'USTIDgeprueft';
    xdsKundendatenKontaktverbund.SetParentComponent(xdsKundendaten);
    xdsKundendatenKontaktverbund.Name := 'xdsKundendatenKontaktverbund';
    xdsKundendatenKontaktverbund.FieldName := 'Kontaktverbund';
    xdsKundendatenKontaktverbund.Size := 25;
    xdsKundendatenHinweis.SetParentComponent(xdsKundendaten);
    xdsKundendatenHinweis.Name := 'xdsKundendatenHinweis';
    xdsKundendatenHinweis.FieldName := 'Hinweis';
    xdsKundendatenHinweis.Size := 255;
    xdsKundendatenLatitude.SetParentComponent(xdsKundendaten);
    xdsKundendatenLatitude.Name := 'xdsKundendatenLatitude';
    xdsKundendatenLatitude.FieldName := 'Latitude';
    xdsKundendatenLongitude.SetParentComponent(xdsKundendaten);
    xdsKundendatenLongitude.Name := 'xdsKundendatenLongitude';
    xdsKundendatenLongitude.FieldName := 'Longitude';
    xdsKundendatenkmLuftlinie.SetParentComponent(xdsKundendaten);
    xdsKundendatenkmLuftlinie.Name := 'xdsKundendatenkmLuftlinie';
    xdsKundendatenkmLuftlinie.FieldName := 'kmLuftlinie';
    xdsKundendatenGoogleID.SetParentComponent(xdsKundendaten);
    xdsKundendatenGoogleID.Name := 'xdsKundendatenGoogleID';
    xdsKundendatenGoogleID.FieldName := 'GoogleID';
    xdsKundendatenGoogleID.Size := 50;
    xdsKundendatenGoogleUpdatedUTC.SetParentComponent(xdsKundendaten);
    xdsKundendatenGoogleUpdatedUTC.Name := 'xdsKundendatenGoogleUpdatedUTC';
    xdsKundendatenGoogleUpdatedUTC.FieldName := 'GoogleUpdatedUTC';
    xdsKundendatenBundesland.SetParentComponent(xdsKundendaten);
    xdsKundendatenBundesland.Name := 'xdsKundendatenBundesland';
    xdsKundendatenBundesland.FieldName := 'Bundesland';
    xdsKundendatenBundesland.Size := 50;
    xdsKundendatenRegion.SetParentComponent(xdsKundendaten);
    xdsKundendatenRegion.Name := 'xdsKundendatenRegion';
    xdsKundendatenRegion.FieldName := 'Region';
    xdsKundendatenRegion.Size := 50;
    xdsKundendatenMandatsreferenz.SetParentComponent(xdsKundendaten);
    xdsKundendatenMandatsreferenz.Name := 'xdsKundendatenMandatsreferenz';
    xdsKundendatenMandatsreferenz.FieldName := 'Mandatsreferenz';
    xdsKundendatenMandatsreferenz.Size := 34;
    xdsKundendatenMandatsreferenzVom.SetParentComponent(xdsKundendaten);
    xdsKundendatenMandatsreferenzVom.Name := 'xdsKundendatenMandatsreferenzVom';
    xdsKundendatenMandatsreferenzVom.FieldName := 'MandatsreferenzVom';
    xdsKundendatenLastschriftArt.SetParentComponent(xdsKundendaten);
    xdsKundendatenLastschriftArt.Name := 'xdsKundendatenLastschriftArt';
    xdsKundendatenLastschriftArt.FieldName := 'LastschriftArt';
    xdsKundendatenLastschriftArt.Size := 2;
    xdsKundendatenMahnsperre.SetParentComponent(xdsKundendaten);
    xdsKundendatenMahnsperre.Name := 'xdsKundendatenMahnsperre';
    xdsKundendatenMahnsperre.FieldName := 'Mahnsperre';
    xdsKundendatenSuchbegriff.SetParentComponent(xdsKundendaten);
    xdsKundendatenSuchbegriff.Name := 'xdsKundendatenSuchbegriff';
    xdsKundendatenSuchbegriff.FieldName := 'Suchbegriff';
    xdsKundendatenSuchbegriff.Size := 25;
    xdsKundendatenLieferanschriftDaten.SetParentComponent(xdsKundendaten);
    xdsKundendatenLieferanschriftDaten.Name := 'xdsKundendatenLieferanschriftDaten';
    xdsKundendatenLieferanschriftDaten.FieldName := 'LieferanschriftDaten';
    xdsKundendatenLieferanschriftDaten.Size := 255;
    xdsKundendatenExportKasse.SetParentComponent(xdsKundendaten);
    xdsKundendatenExportKasse.Name := 'xdsKundendatenExportKasse';
    xdsKundendatenExportKasse.FieldName := 'ExportKasse';
    xdsKundendatenLoeschvormerkungDatum.SetParentComponent(xdsKundendaten);
    xdsKundendatenLoeschvormerkungDatum.Name := 'xdsKundendatenLoeschvormerkungDatum';
    xdsKundendatenLoeschvormerkungDatum.FieldName := 'LoeschvormerkungDatum';
    xdsKundendatenLoeschvormerkungGrund.SetParentComponent(xdsKundendaten);
    xdsKundendatenLoeschvormerkungGrund.Name := 'xdsKundendatenLoeschvormerkungGrund';
    xdsKundendatenLoeschvormerkungGrund.FieldName := 'LoeschvormerkungGrund';
    xdsKundendatenLoeschvormerkungGrund.Size := 250;
    xdsKundendatenPseudonymisiert.SetParentComponent(xdsKundendaten);
    xdsKundendatenPseudonymisiert.Name := 'xdsKundendatenPseudonymisiert';
    xdsKundendatenPseudonymisiert.FieldName := 'Pseudonymisiert';
    xdsKundendatenPseudonymisiert.Size := 255;
    xdsKundendatenLoginAktiv.SetParentComponent(xdsKundendaten);
    xdsKundendatenLoginAktiv.Name := 'xdsKundendatenLoginAktiv';
    xdsKundendatenLoginAktiv.FieldName := 'LoginAktiv';
    xdsKundendatenSonstigeDaten.SetParentComponent(xdsKundendaten);
    xdsKundendatenSonstigeDaten.Name := 'xdsKundendatenSonstigeDaten';
    xdsKundendatenSonstigeDaten.FieldName := 'SonstigeDaten';
    xdsKundendatenSonstigeDaten.Size := 255;
    sourceKundendaten.SetParentComponent(Self);
    sourceKundendaten.Name := 'sourceKundendaten';
    sourceKundendaten.DataSet := xdsKundendaten;
    SetEvent(sourceKundendaten, Self, 'OnStateChange', 'sourceKundendatenStateChange');
    sourceKundendaten.Left := 112;
    sourceKundendaten.Top := 104;
  finally
    TC.AfterLoadDFMValues;
    edtEmail.AfterLoadDFMValues;
    xdsKundendaten.AfterLoadDFMValues;
    xdsKundendatenKundennummer.AfterLoadDFMValues;
    xdsKundendatenGruppeKunden.AfterLoadDFMValues;
    xdsKundendatenGruppeLieferanten.AfterLoadDFMValues;
    xdsKundendatenGruppeSonstige.AfterLoadDFMValues;
    xdsKundendatenGruppeNichtkunden.AfterLoadDFMValues;
    xdsKundendatenKontaktgruppe.AfterLoadDFMValues;
    xdsKundendatenNachname.AfterLoadDFMValues;
    xdsKundendatenVorname.AfterLoadDFMValues;
    xdsKundendatenAdresszeile2.AfterLoadDFMValues;
    xdsKundendatenAdresszeile3.AfterLoadDFMValues;
    xdsKundendatenStrasse.AfterLoadDFMValues;
    xdsKundendatenPostleitzahl.AfterLoadDFMValues;
    xdsKundendatenOrt.AfterLoadDFMValues;
    xdsKundendatenLaenderkuerzel.AfterLoadDFMValues;
    xdsKundendatenLand.AfterLoadDFMValues;
    xdsKundendatenLaenderkennzeichen.AfterLoadDFMValues;
    xdsKundendatenAdressanrede.AfterLoadDFMValues;
    xdsKundendatenBriefanrede1.AfterLoadDFMValues;
    xdsKundendatenAdresseBild.AfterLoadDFMValues;
    xdsKundendatenLieferanschrift.AfterLoadDFMValues;
    xdsKundendatenTelefonNummer.AfterLoadDFMValues;
    xdsKundendatenTelefaxNummer.AfterLoadDFMValues;
    xdsKundendatenMobilTelefon.AfterLoadDFMValues;
    xdsKundendatenEMail.AfterLoadDFMValues;
    xdsKundendatenInternet.AfterLoadDFMValues;
    xdsKundendatenUmsatzsteuerID.AfterLoadDFMValues;
    xdsKundendatenUmsatzsteuerausweis.AfterLoadDFMValues;
    xdsKundendatenZahlungsbedingung.AfterLoadDFMValues;
    xdsKundendatenTransportbedingung.AfterLoadDFMValues;
    xdsKundendatenKeinNewsletter.AfterLoadDFMValues;
    xdsKundendatenTelefonAlternativ.AfterLoadDFMValues;
    xdsKundendatenTitel.AfterLoadDFMValues;
    xdsKundendatenKundenklasseFarbe.AfterLoadDFMValues;
    xdsKundendatenRechnungEmail.AfterLoadDFMValues;
    xdsKundendatenLoginPW.AfterLoadDFMValues;
    xdsKundendatenBesteuerungKey.AfterLoadDFMValues;
    xdsKundendatenAuftraegeJahr.AfterLoadDFMValues;
    xdsKundendatenAuftraegeVorjahr.AfterLoadDFMValues;
    xdsKundendatenLieferadresseID.AfterLoadDFMValues;
    xdsKundendatenUSTIDgeprueft.AfterLoadDFMValues;
    xdsKundendatenKontaktverbund.AfterLoadDFMValues;
    xdsKundendatenHinweis.AfterLoadDFMValues;
    xdsKundendatenLatitude.AfterLoadDFMValues;
    xdsKundendatenLongitude.AfterLoadDFMValues;
    xdsKundendatenkmLuftlinie.AfterLoadDFMValues;
    xdsKundendatenGoogleID.AfterLoadDFMValues;
    xdsKundendatenGoogleUpdatedUTC.AfterLoadDFMValues;
    xdsKundendatenBundesland.AfterLoadDFMValues;
    xdsKundendatenRegion.AfterLoadDFMValues;
    xdsKundendatenMandatsreferenz.AfterLoadDFMValues;
    xdsKundendatenMandatsreferenzVom.AfterLoadDFMValues;
    xdsKundendatenLastschriftArt.AfterLoadDFMValues;
    xdsKundendatenMahnsperre.AfterLoadDFMValues;
    xdsKundendatenSuchbegriff.AfterLoadDFMValues;
    xdsKundendatenLieferanschriftDaten.AfterLoadDFMValues;
    xdsKundendatenExportKasse.AfterLoadDFMValues;
    xdsKundendatenLoeschvormerkungDatum.AfterLoadDFMValues;
    xdsKundendatenLoeschvormerkungGrund.AfterLoadDFMValues;
    xdsKundendatenPseudonymisiert.AfterLoadDFMValues;
    xdsKundendatenLoginAktiv.AfterLoadDFMValues;
    xdsKundendatenSonstigeDaten.AfterLoadDFMValues;
    sourceKundendaten.AfterLoadDFMValues;
  end;
end;

end.